/* eslint-disable */
export default {
  Home: '住家',
  Mobile: '行動電話',
  Work: '公司',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
